import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Stack } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import { MIconButton } from '../../components/@material-extend';
import MyAvatar from '../../components/MyAvatar';
import { CustomMenuPopover } from '../../components/MenuPopover';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import TextMaxLine from 'src/components/TextMaxLine';
import { NAVBAR } from 'src/config';
import EllipsisText from 'src/components/EllipsisText';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Tableau de bord',
    icon: homeFill,
    linkTo: '/'
  },
  {
    label: 'Réglages',
    icon: settings2Fill,
    linkTo: PATH_DASHBOARD.user.account
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover({ onTop = true, sx = {}, sxMenu = {} }) {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const { isCollapse } = useCollapseDrawer();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("une erreur s'est produite", { variant: 'error' });
    }
  };

  return (
    <>
      <MenuItem
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: !onTop && !isCollapse ? NAVBAR.DASHBOARD_WIDTH : 44,
          height: 44,
          justifyContent: 'start',
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          }),
          ...sxMenu
        }}
      >
        <MyAvatar sx={{ ...sx }} />
        <Stack maxWidth={100}>
          {!onTop && !isCollapse && (
            <EllipsisText material text={user.displayName} style={{ color: 'white' }} sx={{ pl: 2 }} />
          )}
        </Stack>
      </MenuItem>

      <CustomMenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
        arrow="left-center"
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            Déconnexion
          </Button>
        </Box>
      </CustomMenuPopover>
    </>
  );
}
